import { Button, Col, Row } from 'antd';
import { FormikProvider, useFormik } from 'formik';
import * as Yup from "yup";
import TextInput from '../inputs/New/TextInput';
import SelectInput from '../inputs/New/SelectInput';
import DatePickerInput from '../inputs/New/DatePickerInput';

import { useCallback, useEffect, useMemo, useState } from 'react';
import { getData } from '../../helpers/api';
import { confirmationStatus } from '../../constants/others';
import { RxReset } from 'react-icons/rx';
import { CiSearch } from 'react-icons/ci';
import useQueryParams from '../../hooks/useQueryParams';

const INITIAL_FILTER = {
    name: "",
    phone: "",
    productName: null,
    startDate: null,
    endDate: null,
    status: null
};

const SheetOrderFilter = () => {
    const { updateQueryParams, queryParams, resetQueryParams } = useQueryParams()
    const [products, setProducts] = useState([]);
    const confirmationStatusValues = useMemo(() => confirmationStatus.map((el) => ({ value: el, label: el })), [])

    const formik = useFormik({
        initialValues: INITIAL_FILTER,
        validationSchema: Yup.object({
            name: Yup.string().nullable().optional(),
            phone: Yup.string().nullable().optional(),
            productName: Yup.string().nullable().optional(),
        }),
        onSubmit: (values) => {
            updateQueryParams({ ...values, page: 1 })
        }
    })

    const getProducts = useCallback(async () => {
        try {
            const res = await getData("/products");
            setProducts(res.data.map((product) => ({ value: product.id, label: product.name })));
        } catch (error) {
            console.log(error);
        }
    }, []);

    useEffect(() => {
        getProducts()
    }, [])

    useEffect(() => {
        formik.setValues({ ...queryParams, productName: queryParams.productName ? parseInt(queryParams.productName) : null })
    }, [])

    return (
        <FormikProvider value={formik}>
            <form onSubmit={formik.handleSubmit} style={{ marginBottom: '20px' }}>
                <Row gutter={[16, 16]}>
                    <Col xl={6} lg={8} md={12} sm={24} xs={24}>
                        <TextInput
                            className="rounded-15"
                            name={`name`}
                            placeholder={"Nom du client"}
                        />
                    </Col>
                    <Col xl={6} lg={8} md={12} sm={24} xs={24}>
                        <TextInput
                            name="phone"
                            placeholder="Téléphone"
                        />
                    </Col>
                    <Col xl={6} lg={8} md={12} sm={24} xs={24}>
                        <SelectInput
                            name="productName"
                            options={products}
                            placeholder={'Produit'}
                        />
                    </Col>
                    <Col xl={6} lg={8} md={12} sm={24} xs={24}>
                        <DatePickerInput
                            name="startDate"
                            placeholder={"Date début de la commande"}
                        />
                    </Col>
                    <Col xl={6} lg={8} md={12} sm={24} xs={24}>
                        <DatePickerInput
                            name="endDate"
                            placeholder={"Date fin de la commande"}
                        />
                    </Col>
                    <Col xl={6} lg={8} md={12} sm={24} xs={24}>
                        <SelectInput
                            name="status"
                            options={confirmationStatusValues}
                            placeholder={'confimation'}
                        />
                    </Col>
                    <Col xs={24} md={6} lg={4}>
                        <Button style={{ marginRight: 5, padding: '15px' }} disabled={!formik.isValid || !formik.dirty} size='small' type="primary" htmlType="submit">
                            <CiSearch />
                        </Button>
                        <Button
                            style={{ marginLeft: 5, padding: '15px' }}
                            disabled={!formik.isValid || !formik.dirty}
                            size='small'
                            color="default"
                            onClick={() => {
                                formik.resetForm()
                                resetQueryParams()
                            }}>
                            <RxReset />
                        </Button>
                    </Col>
                </Row>
            </form>
        </FormikProvider>
    );
}

export default SheetOrderFilter;